<script>
  export let name = null;
  export let action = () => {};
  export let selected = false;
</script>

<button
  aria-label={name}
  on:click={action}
  margin
  class:selected
>
  <slot></slot>
</button>

<style>
  button {
    all: unset;
    -webkit-tap-highlight-color: transparent;
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: white;
    border-radius: 25%;
    background-color: rgba(255, 255, 255, 0);
    transition: background-color 0.25s ease 0s;
  }

  button:hover {
    background-color: rgba(255, 255, 255, 0.05);
  }

  button:focus {
    background-color: rgba(255, 255, 255, 0.15);
  }

  button.selected {
    color: #00BFA5;
  }
</style>
